const SETTINGS = {
  payloads: null,
  disable: true,
  delay: 0,
};

const addVersionToUrl = (url) => {
  const defaultVersion = '6.0';
  if (!url.includes('api-version')) {
    if (url.includes('?')) return (url += `&api-version=${defaultVersion}`);
    else return (url += `?api-version=${defaultVersion}`);
  }
  return url;
};

const PayloadRegister = {
  enable: (flag) => {
    SETTINGS.disable = !flag;
  },

  setRequestDelay: (delay) => {
    SETTINGS.delay = delay;
  },
  registerPayloadBatch: (payloadHash) => {
    Object.values(payloadHash).forEach((payload) => {
      PayloadRegister.registerPayload(payload.method, payload.url, payload.body, payload.response);
    });
  },

  isProduction: () => SETTINGS.disable,

  registerPayload: (method, url, body = null, responseObject) => {
    if (SETTINGS.disable) {
      return;
    }

    if (SETTINGS.payloads === null) {
      SETTINGS.payloads = {};
    }
    url = addVersionToUrl(url);
    const lookupKey = [method, url].join(':').toLowerCase();

    if (!body) {
      body = {};
    }
    if (!SETTINGS.payloads[lookupKey]) {
      SETTINGS.payloads[lookupKey] = [];
    }

    SETTINGS.payloads[lookupKey].push({
      body,
      response: responseObject,
    });
  },

  checkForPayload: (url, request) => {
    if (SETTINGS.disable) {
      return fetch(url, request);
    } else {
      const { method } = request;
      let { body } = request;
      const lookupKeys = [(method + ':' + url).toLowerCase()];

      var theReturnPayload = null;
      if (!body) {
        body = {};
      }

      lookupKeys.forEach((lookupKey) => {
        const payloads = SETTINGS.payloads[lookupKey];

        if (payloads && payloads.length > 0) {
          let foundResponse = null;
          payloads.forEach((payload) => {
            let isValidPayload = true;
            if (payload.body) {
              Object.keys(payload.body).forEach((requiredBodyKey) => {
                if (
                  !body[requiredBodyKey] ||
                  body[requiredBodyKey] !== payload.body[requiredBodyKey]
                ) {
                  isValidPayload = false;
                }
              });
            }
            if (isValidPayload) {
              foundResponse = payload.response;
            }
          });
          if (foundResponse) {
            theReturnPayload = foundResponse;
          }
        }
      });

      if (theReturnPayload) {
        if (SETTINGS.delay) {
          window.setTimeout(() => {
            return new Promise((resolve, reject) => resolve(theReturnPayload));
          }, SETTINGS.delay);
        } else {
          return new Promise((resolve, reject) => resolve(theReturnPayload));
        }
      } else {
        console.error(`Unable to find requested payload! ${method}: ${url}`);

        if (window && SETTINGS.delay) {
          window.setTimeout(() => {
            return fetch(url, request);
          }, SETTINGS.delay);
        } else {
          return fetch(url, request);
        }
      }
    }
  },
};

Object.freeze(PayloadRegister);
export default PayloadRegister;
